import {
  ClassSchedule,
  ExamSessionDetails,
  LecturerWithActivityType,
} from '../../../../../../../../../api/types/programs/course/exams/response/exam-metadata';
import React, { CSSProperties } from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { UserSummaryType } from '../../../../../../../../../api/types/user/user-summary.type';
import { Button } from 'primereact/button';
import globalProgramStore from '../../../../../../../../../stores/program-store';
import globalCourseStore from '../../../../../../../../../stores/global-course-store';
import { examClassScheduleDeleteOperations } from '../../class-schedules/operations/exam-class-schedule-delete-operations';
import { removeProtectorFromSchedulingOperation } from './operations/remove-protector-from-scheduling-operation';

interface ClassProtectorsDatamodel {
  protectors: LecturerWithActivityType[];
  examId: number;
  sessionId: number;
  classesSchedule?: ClassSchedule;
  setSessionDetails: (sessions: ExamSessionDetails[]) => any;
}
const color1 = '#F0FDFFFF';
const color2 = 'rgb(135 185 193)';
const columnStyle: CSSProperties = {
  textAlign: 'right',
  minWidth: '30px',
  maxWidth: '30px',
  color: '#287a99',
  backgroundColor: color1,
  borderBottom: `1px solid ${color2}`,
};

export const ClassProtectors: React.FC<ClassProtectorsDatamodel> = ({
  protectors,
  examId,
  sessionId,
  classesSchedule,
  setSessionDetails,
}) => {
  const handleDelete = async (scheduleId: number) => {
    const programId = globalProgramStore.getCurrentId();
    const currentCourseId = globalCourseStore.getCurrentCourse()?.metadata.id;
    await removeProtectorFromSchedulingOperation(
      programId,
      currentCourseId,
      examId,
      scheduleId,
      classesSchedule?.scheduleId,
      setSessionDetails,
    );
  };

  return (
    <div>
      <DataTable
        emptyMessage={
          <div style={{ textAlign: 'right' }}>
            לא נמצאו משגיחים, ניתן להוסיף משגיחים
          </div>
        }
        selectionMode={'multiple'}
        multiple={true}
        groupRowsBy="dsf"
        value={protectors ?? []}
        scrollable
        showHeaders={false}
        onSelectionChange={(e) => {
          //setSelectedUsers(e.value as UserSummaryType[]);
        }}
        dataKey="id"
        tableStyle={{
          direction: 'rtl',
          borderColor: '#860c0c',
        }}
      >
        <Column
          expander={true}
          style={{
            width: '45px',
            minWidth: '45px',
            maxWidth: '45px',
            textAlign: 'right',
            borderBottom: `1px solid ${color2}`,

            backgroundColor: color1,
          }}
          body={() => <div></div>}
        />
        <Column
          expander={true}
          header="שם"
          field={'firstName'}
          style={columnStyle}
          body={(rowData: UserSummaryType) => (
            <label style={{ fontWeight: '450' }}>
              {rowData.firstName} {rowData.lastName}
            </label>
          )}
        />

        <Column header="ת.ז" field={'nationalId'} style={columnStyle} />

        <Column
          header="סוג פעילות"
          field={'typeRateName'}
          style={columnStyle}
          body={(data, option) => <div style={{}}>asdas</div>}
        />

        <Column
          expander={false}
          header="שעת התחלה"
          field={'className'}
          style={columnStyle}
          body={(rowData: ClassSchedule) => <label></label>}
        />

        <Column
          expander={false}
          header="שעת סיום"
          field={'className'}
          style={columnStyle}
          body={(rowData: ClassSchedule) => <label></label>}
        />

        <Column
          expander={false}
          field={'createdByName'}
          style={columnStyle}
          body={(rowData: ClassSchedule) => (
            <Button
              icon="pi pi-trash"
              text
              severity="danger"
              onClick={() => handleDelete(rowData.scheduleId)}
            />
          )}
        />
      </DataTable>
    </div>
  );
};
